import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import "./Stage2Certificate.scss";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/NewIcons/IconDownloadWhie.svg";
import { ReactComponent as CrossIcon } from "../../../assets/icons/NewIcons/exitIcon.svg";
import certificateImg from "../../../assets/images/Phase 2 Template (1).jpg";
import ShareCertiWithSocialmedia from "../ShareCertiWithSocialmedia";

const Stage2Certificate = ({ data, publicShareTrue }) => {
  const certificate = data;
  const [open, setOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(
    publicShareTrue ? data : null
  );
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleOpen = (certificate) => {
    setSelectedCertificate(certificate);
    setOpen(true); // Open modal
    setImageLoaded(false); // Reset imageLoaded for new modal
  };

  const handleClose = () => {
    setOpen(false); // Close modal
    setSelectedCertificate(null);
  };

  const handleNavigationLinks = (url) => {
    window.open(url, "_blank");
  };

  const downloadCertificateWithDetails = () => {
    const certificateElement = document.getElementById("certificateContainer");

    if (certificateElement) {
      html2canvas(certificateElement, {
        scale: 4, // Ensure high resolution
        useCORS: true, // Enable cross-origin images
      }).then((canvas) => {
        // Create a new canvas for fixed dimensions
        const resizedCanvas = document.createElement("canvas");
        resizedCanvas.width = 1968; // Fixed width
        resizedCanvas.height = 1483; // Fixed height

        const context = resizedCanvas.getContext("2d");
        context.drawImage(
          canvas,
          0,
          0,
          canvas.width,
          canvas.height,
          0,
          0,
          resizedCanvas.width,
          resizedCanvas.height
        );

        // Convert resized canvas to image
        const dataUrl = resizedCanvas.toDataURL("image/png");

        // Trigger download
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${selectedCertificate?.name}_certificate.png`;
        link.click();
      });
    } else {
      console.error("Certificate element not found for download.");
    }
  };

  const handleSmallDownload = () => {
    // Open the modal first
    setOpen(true);
    setSelectedCertificate(certificate);

    setTimeout(() => {
      // Trigger the download automatically
      downloadCertificateWithDetails();
    }, 300); // Adding a slight delay to ensure the modal is opened before the download happens
  };
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  return (
    <>
      {!publicShareTrue && (
        <div className="stage2certificateSmallerContainer">
          <div className="certificateSmallerWrapper">
            <div key={certificate.id} className="small_certificate_container">
              <div className="topSection">
                <div className="downloadBtn">
                  <DownloadIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSmallDownload(); // Trigger download when small download button is clicked
                    }}
                  />
                </div>
                <div className="certificateTitle">
                  <h3 className="certificate_title">{certificate?.title}</h3>
                </div>
              </div>
              <div className="certificateImgContainer">
                <img
                  src={certificateImg}
                  alt="Certificate"
                  className="small_certificate_image"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpen(certificate)} // Open modal when certificate image is clicked
                />
                <div className="small_certificate_name">
                  {certificate?.name}
                </div>
                <div className="small_certificate_date">
                  {certificate?.created_at}
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Section */}
      {(open || publicShareTrue) && (
        <div
          className={`${
            publicShareTrue ? "stage1certificateCardOverlayShare" : ""
          } stage2certificateCardOverlay`}
          onClick={handleClose}
        >
          {" "}
          <div
            className="certificateCardContainer"
            onClick={(e) => e.stopPropagation()} // Prevent click on container from closing modal
          >
            <div className="certificateCardWrapper">
              <div className="certificateDetail certificatePopModalHeader">
                <div className="topSection">
                  <div className="certificateTitle">
                    <p>{selectedCertificate?.title}</p>
                  </div>
                </div>
                <div className="bottomSection">
                  <div className="downloadBtn">
                    <DownloadIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadCertificateWithDetails(); // Trigger download when download button in modal is clicked
                      }}
                    />
                  </div>
                  {!publicShareTrue && (
                    <div className="rightSection">
                      <ShareCertiWithSocialmedia data={selectedCertificate} />

                      <div className="crossBtn">
                        <CrossIcon onClick={handleClose} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="certificateImage" id="certificateContainer">
                <img
                  src={certificateImg}
                  alt="Certificate"
                  className="certificate_image"
                  style={{ cursor: "pointer" }}
                  onLoad={() => setImageLoaded(true)} // Set imageLoaded flag to true after the image is loaded
                />
                {imageLoaded && (
                  <>
                    <div className="certificateReceiver">
                      <p>{selectedCertificate?.name}</p>
                    </div>
                    <div className="certificateIssueDate">
                      <p>{selectedCertificate?.created_at}</p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Stage2Certificate;
